import { render, staticRenderFns } from "./overlay-drawer-artwork-image.vue?vue&type=template&id=d34a4a84"
import script from "./overlay-drawer-artwork-image.vue?vue&type=script&lang=js"
export * from "./overlay-drawer-artwork-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports